<template>
    <div class="grid justify-items-center h-screen w-full bg-gradient-to-r from-purple-300 to-blue-300 bg-cover">
        <div class="self-center">
            <div class="float-left text-xl font-semibold mb-2">Who are you?</div>
            <div><input v-model="name" type="text" placeholder="Name" class="border-2 border-gray-800 shadow-2xl rounded h-8 w-80 px-2  focus:outline-none focus:ring focus:border-blue-100 "></div>
            <button @click="joinRoom()" class="float-left mt-4 border-2 shadow-2xl rounded h-8 w-32 border-gray-500 bg-green-300 font-semibold  hover:bg-green-200">Join Room</button>
            <div>{{error}}</div>
        </div>
    </div>
</template>

<script>
import io from 'socket.io-client'
export default {
    data(){
        return{
            name: "",
            error: ""
        }
    },
    methods:{
        joinRoom(){
            if (!/\S/.test(this.name)) {
                this.error = "The name field can't be empty"
            }
            else if(this.name.length > 18){
                this.error = "Your name has to be shorter than 18 characters"
            }
            else{
                const socket = io('cuberivals.herokuapp.com')
                this.$store.commit("SetSocket", {socket: socket})
                this.$store.commit('updateName', {name: this.name})
                this.$router.push("/" + this.$store.state.roomId)
            }
        }
    }
}
</script>
<style>

</style>